import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=530a5f3d&scoped=true&"
import script from "./step3.vue?vue&type=script&lang=js&"
export * from "./step3.vue?vue&type=script&lang=js&"
import style0 from "./step3.vue?vue&type=style&index=0&id=530a5f3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a5f3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530a5f3d')) {
      api.createRecord('530a5f3d', component.options)
    } else {
      api.reload('530a5f3d', component.options)
    }
    module.hot.accept("./step3.vue?vue&type=template&id=530a5f3d&scoped=true&", function () {
      api.rerender('530a5f3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/fission/detail/step3.vue"
export default component.exports